{
  "rampInfoCard": {
    "labels": {
      "aircraft": "Flugzeug",
      "utilization": "Auslastung",
      "wind": "Wind",
      "trips": "Flüge",
      "grossDimensions": "Bruttomaße",
      "parkableArea": "Parkfläche"
    },
    "tooltips": {
      "aircraftOnRamp": "Flugzeuge innerhalb der Ramp-Markierung geparkt / Alle Flugzeuge auf dem Bildschirm angezeigt.",
      "parkableArea": "Markierte Abstellflächen, ausgenommen nicht befahrbare Bereiche (z. B. Rollwege, Hindernisse).",
      "utilization": "Luftfahrzeuge innerhalb der Ramp-Markierung geparkt / Alle Luftfahrzeuge auf dem Bildschirm. (Hinweis: Ein Luftfahrzeug gilt als geparkt, wenn sich das Hauptfahrwerk innerhalb der Ramp-Markierung befindet)",
      "grossDimensions": "Grundlegende Länge und Breite der Vorfeldumrandung",
      "trips": "Aktive Flüge / Zukünftige Flüge für dieses Ramp",
      "wind": {
        "loading": "Aktuelle Windbedingungen von der nächsten Wetterstation (alle 5 Minuten aktualisiert)",
        "error": "Winddaten von {{stationInfo}} nicht verfügbar\nZuletzt geprüft: {{lastUpdated}}\nAktualisiert alle 5 Minuten",
        "current": "Aktuelle Windbedingungen von {{stationInfo}}\nZuletzt aktualisiert: {{lastUpdated}}\nAktualisiert alle 5 Minuten"
      }
    }
  },
  "namePrefixes": {
    "allTenants": "[Alle Mandanten]",
    "allTieDownTenants": "[Alle Außenabstellplatz-Mieter]"
  },
  "aircraftFinder": {
    "tooltip": "Flugzeug suchen",
    "searchPlaceholder": "Suche Kennung, Modell, Betreiber",
    "clear": "Löschen"
  },
  "autoPark": {
    "dialog": {
      "title": "AutoPark-Konfiguration",
      "tabs": {
        "timeRange": "Zeitraum",
        "algorithm": "Algorithmus"
      },
      "timeRange": {
        "startTime": "Startzeit",
        "endTime": "Endzeit",
        "duration": "Dauer",
        "presets": {
          "oneDay": "1 Tag",
          "threeDays": "3 Tage",
          "sevenDays": "7 Tage"
        },
        "tripSelection": "Flüge im ausgewählten Zeitraum: {{selected}} von {{total}} ausgewählt"
      },
      "buttons": {
        "cancel": "Abbrechen",
        "run": "AutoPark starten"
      }
    },
    "button": {
      "label": "AutoPark",
      "disabledMessage": "AutoParking ist für dieses Vorfeld nicht aktiviert. Aktiviere es in den Vorfeldeinstellungen.",
      "tooltip": "AutoPark"
    },
    "decisionLog": {
      "tabs": {
        "spotOccupancy": "Stellplatzbelegung",
        "listView": "Listenansicht",
        "timelineDev": "Timeline (Dev)",
        "decisionLog": "Entscheidungsprotokoll ({{count}} Flugzeuge)"
      },
      "statistics": {
        "aircraftPlaced": "Flugzeug platziert",
        "successRate": "Erfolgsquote",
        "unplacedAircraft": "Unplatzierte Flugzeuge",
        "partiallyPlaced": "Teilweise platziert",
        "partialPlacementNote": "Für einen Teil des Fluges platziert",
        "averageMoves": "Ø Bewegungen",
        "executionTime": "Ausführungszeit"
      },
      "filters": {
        "all": "Alle ({{count}})",
        "placed": "Platziert ({{count}})",
        "unplaced": "Nicht platziert ({{count}})"
      },
      "buttons": {
        "close": "Schließen",
        "apply": "Auf Ramp anwenden",
        "applying": "Anwenden..."
      },
      "progress": {
        "title": "Ergebnisse werden in Datenbank übernommen",
        "message": "Flugzeugpositionen werden in der Datenbank gespeichert. Bitte warten...",
        "itemName": "Platzierung"
      }
    },
    "placementTable": {
      "headers": {
        "status": "Status",
        "tailNumber": "Kennz.",
        "spots": "Plätze",
        "arrival": "Ankunft",
        "departure": "Abflug",
        "dwell": "Verweil"
      },
      "summary": {
        "showing": "Zeige {{filtered}} von {{total}}",
        "placed": "{{count}} platziert",
        "unplaced": "{{count}} nicht platziert"
      },
      "filters": {
        "all": "Alle",
        "placed": "Platziert",
        "unplaced": "Offen",
        "searchPlaceholder": "Suche Kennzeichen..."
      }
    },
    "tripList": {
      "title": "Flüge ({{selected}}/{{total}} ausgewählt)",
      "locked": "{{count}} gesperrt",
      "buttons": {
        "all": "Alle",
        "none": "Keine",
        "lockAll": "Alle sperren",
        "unlockAll": "Alle entsperren",
        "includeAll": "All",
        "excludeAll": "None"
      },
      "tooltips": {
        "lockAll": "Alle Flüge sperren (Positionen beibehalten)",
        "unlockAll": "Alle Trips entsperren (Umparken erlauben)",
        "includeAll": "Include all trips in calculation",
        "excludeAll": "Exclude all trips from calculation",
        "lock": "Sperren (Position beibehalten)",
        "unlock": "Entsperren (Umparken erlauben)",
        "clickToLock": "Click to lock position",
        "clickToExclude": "Click to exclude",
        "clickToInclude": "Click to include",
        "keyboardHint": "↑↓ Navigieren • Leertaste Auswählen • L Sperren • Umschalt+L Alle sperren"
      },
      "filter": {
        "placeholder": "Tail, Hersteller, Modell filtern..."
      },
      "emptyState": {
        "title": "Keine Flüge im ausgewählten Zeitraum",
        "hint": "Versuche den Datumsbereich mit den 3d- oder 7d-Buttons oben zu erweitern, oder prüfe, ob dieses Vorfeld geplante Flüge hat.",
        "addTrips": "Flüge können in der Zeitplanansicht hinzugefügt werden."
      },
      "current": "Aktuell:",
      "invalidDates": "Ungültige Daten",
      "unknownAircraft": "Unbekanntes Flugzeug",
      "sizeCategories": {
        "small": {
          "label": "S",
          "tooltip": "Klein (<50ft Spannweite)"
        },
        "medium": {
          "label": "M",
          "tooltip": "Mittel (50-80ft Spannweite)"
        },
        "large": {
          "label": "L",
          "tooltip": "Groß (80-120ft Spannweite)"
        },
        "extraLarge": {
          "label": "XL",
          "tooltip": "Extra groß (>120ft Spannweite)"
        }
      },
      "noTrips": "Keine Flüge im ausgewählten Zeitraum",
      "assign": "Zuweisen",
      "selectLocation": "Standort auswählen",
      "hangarsSection": "Hangars",
      "rampsSection": "Andere Vorfelder"
    },
    "assignSuccess": "{{tailNumber}} wurde {{locationName}} zugewiesen",
    "assignError": "Flugzeug konnte nicht zugewiesen werden",
    "capacityBar": {
      "title": "Stellplatzkapazität",
      "utilization": "{{placed}}/{{total}} Plätze ({{percent}} % ausgelastet)",
      "legend": {
        "placed": "Platziert ({{count}})",
        "available": "Verfügbar ({{count}})",
        "filtered": "Gefiltert ({{count}})",
        "breakdown": {
          "time": "Zeit ({{count}})",
          "size": "Größe ({{count}})",
          "duration": "Dauer ({{count}})",
          "disabled": "Deaktiviert ({{count}})",
          "geometry": "Geometrie ({{count}})"
        }
      }
    },
    "parkNextButton": {
      "label": "Weiter parken",
      "tooltip": "Nächst. Park",
      "disabledMessage": "Keine unplatzierten Flugzeuge verfügbar."
    },
    "decisionLogButton": {
      "tooltip": "Entscheidungslog anzeigen",
      "disabledTooltip": "Erst AutoPark ausführen"
    },
    "unplacedAircraftDialog": {
      "title": "Nicht platzierte Flugzeuge um {{time}}",
      "subtitle": "{{count}} Flugzeuge konnten derzeit nicht platziert werden",
      "noAircraft": "Derzeit keine unplatzierten Flugzeuge",
      "closeLabel": "Schließ"
    },
    "timeRangePicker": {
      "durationFormat": {
        "daysHoursMinutes": "{{days}}T {{hours}}Std {{minutes}}Min",
        "hoursMinutes": "{{hours}}h {{minutes}}m",
        "minutes": "{{minutes}} Min."
      }
    },
    "scheduleGanttDialog": {
      "title": "{{rampName}} Zeitplan",
      "statistics": {
        "aircraftPlaced": "Flugzeug platziert",
        "avgUtilization": "Durchschn. Auslastung"
      },
      "buttons": {
        "print": "Drucken",
        "close": "Schließen",
        "applyToDatabase": "Auf Datenbank anwenden",
        "applying": "Anwenden..."
      },
      "messages": {
        "unsavedChanges": "Du hast ungespeicherte Änderungen. Möchtest du wirklich schließen?",
        "pendingChanges": "{{count}} ungespeicherte Änderung"
      },
      "labels": {
        "close": "Schließ"
      }
    },
    "editableSpotCell": {
      "otherSpots": "Andere Spots"
    },
    "placementTableRowExpanded": {
      "segmentBreakdown": "Segmentübersicht ({{segmentCount}} Segment, {{moveCount}} Bewegung)",
      "partialPlacement": "Teilplatzierung - {{count}} Lücke",
      "placed": "Platziert:",
      "gap": "Lücke:",
      "gapLabel": "Lücke {{index}}:",
      "noAvailableSpots": "Keine verfügbaren Plätze gefunden",
      "checkDecisionLog": "Entscheidungsprotokoll-Tab für Filterdetails prüfen"
    },
    "spotSchedulePrintView": {
      "unknownType": "Unbekannter Typ",
      "segmentNotes": "Segment {{current}}/{{total}} ({{moves}} Züge)",
      "title": "AutoPark-Ergebnisse - {{rampName}} - {{dateRange}}",
      "statistics": {
        "aircraftPlaced": "Flugzeug platziert",
        "successRate": "Erfolgsquote",
        "averageMoves": "Ø Bewegungen"
      },
      "tableHeaders": {
        "tailNumber": "Kennzeichen",
        "aircraftType": "Flugzeugtyp",
        "arrival": "Ankunft",
        "departure": "Abflug",
        "duration": "Dauer",
        "notes": "Notizen"
      },
      "noAircraftScheduled": "(Keine Flugzeuge geplant)",
      "unplacedAircraft": "Nicht zugewiesene Flugzeuge ({{count}})"
    },
    "placementList": {
      "title": "Parkplatzzuweisungen",
      "sections": {
        "placed": "Platziert",
        "unplaced": "Offen"
      },
      "headers": {
        "tail": "Kz.",
        "spot": "Spot",
        "zone": "Zone",
        "time": "Zeit"
      },
      "labels": {
        "allows": "erlaubt",
        "coverage": "Abdeckung",
        "requested": "Anf.",
        "spotLock": "{{count}} Slot-Sperre",
        "move": "{{count}} Zug",
        "moveAt": "@ {{time}}"
      },
      "tooltips": {
        "sizeVerySmall": "Sehr klein (z. B. Cessna 172)",
        "sizeSmall": "Klein (z. B. Citation, Phenom 300)",
        "sizeMidsize": "Mittelgroß (z. B. Challenger 604)",
        "sizeSuperMidsize": "Super-Midsize (z. B. Gulfstream G650)",
        "sizeLarge": "Groß (z. B. Global 7500, BBJ)",
        "sizeEnormous": "Riesig (z. B. Verkehrsflugzeuge)",
        "blocksOne": "Blockiert {{tailNumber}} (Abflug {{departureTime}})",
        "blocksMultiple": "Blockiert {{count}} Flugzeuge: {{tailNumbers}}"
      }
    },
    "timelineView": {
      "title": "Abstellplatz-Belegung ({{horizonHours}}h Zeitfenster)",
      "headers": {
        "zone": "Zone",
        "spot": "Spot",
        "day": "Tag {{dayNumber}}"
      },
      "rows": {
        "utilization": "Auslastung",
        "placed": "Platziert",
        "unplaced": "Offen"
      },
      "labels": {
        "disabled": "(DEAKTIVIERT)",
        "stagingArrival": " (A)",
        "stagingDeparture": " (D)"
      },
      "tooltips": {
        "spotDisabled": "Spot deaktiviert (für Algorithmus nicht verfügbar)",
        "zoneDisabled": "{{zoneName}} deaktiviert (alle Plätze in Zone nicht verfügbar)",
        "spotAndZoneDisabled": "Spot deaktiviert UND {{zoneName}} deaktiviert",
        "departing": "Abflug: {{tailNumbers}}",
        "unplacedAircraft": "{{tailNumbers}} (für Details klicken)",
        "blocked": "Blockiert durch {{tailNumber}} an {{spotId}} (Abflug {{departureTime}})"
      }
    },
    "parkingConfigForm": {
      "time": {
        "min": "min",
        "hour": "Stunde",
        "hours": "Stunden",
        "disabled": "0 Min. (deaktiviert)"
      },
      "buffer": {
        "title": "Puffer",
        "helpText": "Zusätzliche Zeit (Minuten), die vor der Ankunft und nach dem Abflug hinzugefügt wird, um enge Zeitkonflikte zu vermeiden. Beispiel: Ein Flugzeug startet um 10:00 Uhr. Mit 15 Minuten Puffer wird der Stellplatz um 10:15 Uhr verfügbar.",
        "options": {
          "none": "Kein Puffer (0)",
          "minutes10": "10 Minuten",
          "standard": "Standard (15)",
          "high": "Hoch (20)"
        }
      },
      "plannedMoves": {
        "title": "Geplante Bewegungen",
        "helpText": "Maximale Anzahl der Umpositionierungen eines Flugzeugs während der Standzeit. 0 = keine Bewegungen (Flugzeug bleibt an einer Position). Beispiel: Bei 1 erlaubten Bewegung könnte das Flugzeug an Spot A (8:00-12:00) parken und dann zu Spot B (12:00-16:00) wechseln.",
        "options": {
          "none": "Keine Splits (0)",
          "allow1": "1 Verschiebung",
          "allow2": "Erlaube 2 Züge",
          "allow3": "Erlaube 3 Züge"
        }
      },
      "allowTrapping": {
        "title": "Trapping erlauben",
        "helpText": "Wenn aktiviert, können Flugzeuge auch auf Positionen platziert werden, die Abfahrtswege anderer blockieren. Wenn deaktiviert, werden Flugzeuge nur auf Positionen platziert, die andere nicht einschließen (einige Flugzeuge bleiben möglicherweise unplatziert).",
        "label": "Trapping erlauben"
      },
      "egressWeight": {
        "title": "Abfluggewicht",
        "helpText": "Steuert, wie stark der Algorithmus Platzierungen vermeidet, die andere Flugzeuge blockieren. Niedrig (1x): minimale Gewichtung. Mittel (2x): moderate Gewichtung. Hoch (5x): starke Gewichtung.",
        "options": {
          "low": "Niedrig (1x)",
          "medium": "Mittel (2x)",
          "high": "Hoch (5x)"
        }
      },
      "wasteWeight": {
        "title": "Abfallgewicht",
        "helpText": "Steuert, wie stark der Algorithmus vermeidet, kleine Flugzeuge auf überdimensionierten Stellplätzen zu platzieren. Hilft dabei, Premium-Großstellplätze für große Flugzeuge zu reservieren, die sie tatsächlich benötigen.",
        "options": {
          "disabled": "Deaktiviert (0x)",
          "low": "Niedrig (0,5×)",
          "medium": "Mittel (1x)",
          "high": "Hoch (2x)",
          "veryHigh": "Sehr hoch (3x)"
        }
      },
      "structuralWeight": {
        "title": "Strukturgewicht",
        "helpText": "Steuert die Strafe für Spots mit komplexer Blockierungstopologie. Bevorzugt zuerst saubere Spots, komplexe Spots werden als letzte Option genutzt. Niedrig (0,05x): minimal. Standard (0,1x): bei Gleichstand. Hoch (0,5x): starke Präferenz.",
        "options": {
          "disabled": "Deaktiviert (0x)",
          "low": "Niedrig (0,05x)",
          "standard": "Standard (0,1x)",
          "medium": "Mittel (0.2x)",
          "high": "Hoch (0,5x)"
        }
      },
      "zonePriorityWeight": {
        "title": "Zonenpriorität",
        "helpText": "Steuert die Präferenz für Zonen mit hoher Priorität. Deaktiviert (0x): Zonen ignorieren. Niedrig (0,5x): geringe Präferenz. Standard (1x): ausgewogen. Hoch (2x): starke Präferenz. Sehr hoch (3x): maximale Präferenz.",
        "options": {
          "disabled": "Deaktiviert (0x)",
          "low": "Niedrig (0,5x)",
          "standard": "Standard (1x)",
          "high": "Hoch (2x)",
          "veryHigh": "Sehr hoch (3x)"
        }
      },
      "minDwellWeight": {
        "title": "Min. Standgewicht",
        "helpText": "Steuert die Präferenz für Positionen mit Mindeststandzeit. Zieht Langzeit-Flugzeuge zu abgelegenen/Überlauf-Positionen und weist Kurzzeit-Flugzeuge ab. Deaktiviert (0x): Mindeststandzeit ignorieren. Niedrig (0,5x): geringe Präferenz. Standard (1x): ausgewogen. Hoch (2x): starke Präferenz. Sehr hoch (3x): maximale Präferenz.",
        "options": {
          "disabled": "Deaktiviert (0x)",
          "low": "Niedrig (0,5x)",
          "standard": "Standard (1x)",
          "high": "Hoch (2x)",
          "veryHigh": "Sehr hoch (3x)"
        }
      },
      "arrivalStagingTime": {
        "title": "Ankunft-Staging",
        "helpText": "Dauer für Ankunfts-Abfertigung: Entladen, Zoll, Betankung, Reinigung. Auf 0 setzen, um Ankunfts-Staging zu deaktivieren. Erfordert konfigurierte Staging-Zonen auf dem Vorfeld. Gültiger Bereich: 0–{{max}} Minuten."
      },
      "departureStagingTime": {
        "title": "Abflug-Staging",
        "helpText": "Dauer für die Abflugvorbereitung: Boarding, letzte Checks, Papierkram. Auf 0 setzen, um das Departure Staging zu deaktivieren. Erfordert konfigurierte Staging-Zonen auf dem Vorfeld. Gültiger Bereich: 0–{{max}} Minuten."
      },
      "quickTurnThreshold": {
        "title": "Quick-Turn",
        "helpText": "Minimale Gesamtverweildauer für den Staging-Workflow. Flugzeuge mit kürzeren Aufenthalten überspringen das Staging und werden direkt auf permanente Positionen zugewiesen. Gültiger Bereich: {{min}}-{{max}} Minuten.",
        "options": {
          "hour1": "1 Stunde",
          "hours1_5": "1,5 Stunden",
          "standard": "Standard (2 Stunden)",
          "hours3": "3 Stunden",
          "hours4": "4 Stunden"
        }
      },
      "sortingStrategy": {
        "title": "Sortierstrategie",
        "helpText": "Steuert die Reihenfolge, in der Aircraft verarbeitet werden. Größenbeschränkt: platziert Aircraft mit weniger Spot-Optionen zuerst. Ankunft: verarbeitet nach Ankunftszeit. Hybrid: kombiniert größenbeschränkt + längste Standzeit.",
        "options": {
          "arrival": "Ankunftsreihenfolge",
          "sizeConstrained": "Größe zuerst",
          "longestDwell": "Längste Verweildauer zuerst",
          "latestDeparture": "Neueste Abflüge zuerst",
          "hybrid": "Hybrid (Größe + Dauer)",
          "largestFirst": "Größte zuerst"
        }
      }
    },
    "editableTimeCell": {
      "placeholder": "HH:mm"
    },
    "index": {
      "disabledMessages": {
        "autoParkingNotEnabledWithSettings": "AutoParking ist für dieses Vorfeld nicht aktiviert. Aktiviere es in den Vorfeldeinstellungen.",
        "autoParkingNotEnabled": "AutoParking ist für dieses Vorfeld nicht aktiviert.",
        "noUnplacedAircraft": "Keine unplatzierten Flugzeuge verfügbar."
      },
      "buttons": {
        "checkFit": "Passform ok?"
      }
    },
    "spotOccupancyGantt": {
      "sizeCategories": {
        "verySmall": "Sehr klein",
        "small": "Klein",
        "midsize": "Mittelgroß",
        "superMidsize": "Super-Midsize",
        "large": "Groß",
        "enormous": "Riesig"
      },
      "errors": {
        "spotNotFound": "Platz nicht gefunden"
      },
      "unknownType": "Unbekannter Typ",
      "staging": {
        "arrival": "Ankunfts-Staging",
        "departure": "Abflugbereitstellung"
      },
      "moveCount": "{{count}} Zug",
      "currentlyViewing": "Aktuelle Ansicht:"
    },
    "legend": {
      "title": "Farblegende",
      "auto": "Auto-zugewiesen",
      "manual": "Manuell",
      "staging": "Staging-Bereich",
      "locked": "Gesperrt"
    },
    "planningDialog": {
      "title": "AutoPark-Planung",
      "stats": {
        "placed": "{{placed}}/{{total}} platziert",
        "rate": "{{percent}}% Rate"
      },
      "buttons": {
        "preview": "Vorschau",
        "running": "Läuft...",
        "print": "Drucken",
        "settings": "Einstellung",
        "applyToRamp": "Auf Ramp anwenden",
        "applying": "Anwenden...",
        "cancel": "Abbrechen"
      },
      "tooltips": {
        "noTripsInRange": "Keine Flüge im Zeitraum",
        "unlockToPreview": "Trips entsperren für Vorschau",
        "showTripList": "Trips anzeigen",
        "hideTripList": "Tripliste ausblenden",
        "configureAlgorithm": "Konfiguriere, wie AutoPark Flugzeuge platziert. Voreinstellungen bieten schnelle Konfigurationen, oder passe die einzelnen Gewichtungen unten an."
      },
      "presets": {
        "label": "Vorlage",
        "balanced": {
          "label": "Ausgewogen (Standard)",
          "description": "Gute Balance zwischen Effizienz und Stabilität"
        },
        "conservative": {
          "label": "Konservativ",
          "description": "Bewegungen minimieren, Stabilität priorisieren"
        },
        "aggressive": {
          "label": "Aggressiv",
          "description": "Raumeffizienz maximieren"
        },
        "custom": {
          "label": "Eigene",
          "description": "Manuelle Konfiguration"
        }
      },
      "workflow": {
        "title": "So funktioniert AutoPark",
        "step1": "<strong>Wähle Trips</strong> im linken Bereich aus, um sie in die Planung einzubeziehen",
        "step2": "<strong>Trips sperren</strong>, die du an ihrer aktuellen Position behalten möchtest",
        "step3": "<strong>Klicke auf „Vorschau ausführen\"</strong>, um die Vorschläge des Algorithmus zu sehen",
        "step4": "<strong>Änderungen überprüfen</strong>, dann auf Ramp anwenden",
        "footer": "Gesperrte Trips bleiben an ihrem Platz. Entsperrte Trips können neue Positionen erhalten – basierend auf Größe, Ankunftszeit und Zonenprioritäten."
      },
      "algorithmSettings": "Algorithmus-Einstellungen"
    },
    "impactSummary": {
      "locked": "gesperrt",
      "moving": "Bewegen",
      "new": "Neu",
      "conflicts": "Konflikte",
      "tooltips": {
        "locked": "{{count}} Flüge bleiben an ihren aktuellen Positionen",
        "moving": "{{count}} Flüge werden an neue Positionen verschoben",
        "new": "{{count}} zuvor nicht zugewiesene Trips erhalten Plätze",
        "conflicts": "{{count}} Flüge konnten nicht platziert werden",
        "utilization": "Spot-Auslastung geändert: {{before}}% → {{after}}%"
      },
      "details": {
        "moves": "Bewegungen ({{count}}):",
        "conflicts": "Konflikte ({{count}}):"
      },
      "unknown": "Unbekannt"
    }
  },
  "ramp": {
    "referenceModeAlert": "Das ist deine Tie Town Tenant Reference Ramp. Sie zeigt nur deine Tie-Down-Mieter und unterscheidet sich von deiner aktiven Current Ramp."
  },
  "rampPrintLayout": {
    "aircraft": "Flugzeug",
    "footer": {
      "automaticallyOptimizedBy": "Automatisch optimiert von",
      "contactInfo": "Kontaktiere uns unter www.airplx.com oder peter@airplx.com."
    }
  },
  "temporalTest": {
    "index": {
      "title": "Temporaler Parktest",
      "testScenario": "Testszenario",
      "buttons": {
        "running": "Läuft...",
        "runPlanner": "Routenplaner"
      },
      "stats": {
        "planningStatistics": "Planungsstatistiken",
        "totalAircraft": "Flugzeuge gesamt:",
        "placed": "Platziert:",
        "unplaced": "Offen:",
        "plannedMoves": "Geplante Bewegungen:",
        "traps": "Fallen:",
        "aircraftBlocking": "Flugzeugblockierung",
        "others": "andere",
        "none": "Keine ✓",
        "expected": "Erwartet:",
        "placedSlash": "platziert /",
        "unplacedSuffix": "unplatziert",
        "matchCheck": " ✓",
        "mismatch": " (abweichend)"
      },
      "instructions": "Wähle ein Szenario und klicke auf Planer starten, um Parkplatzzuweisungen zu erstellen",
      "decisionLog": "Entscheidungsprotokoll ({{count}} Ereignisse)",
      "parameterGuide": {
        "title": "Parameterleitfaden",
        "buffer": {
          "title": "Puffer",
          "description": "Zusätzliche Zeit (Minuten), die vor der Ankunft und nach dem Abflug hinzugefügt wird, um enge Zeitkonflikte zu vermeiden.",
          "example": "Beispiel: Flugzeug A startet um 10:00 Uhr. Mit 15 Min. Puffer wird der Stellplatz um 10:15 Uhr frei – so werden hektische Turnarounds vermieden."
        },
        "plannedMoves": {
          "title": "Geplante Bewegungen",
          "description": "Maximale Anzahl der Umpositionierungen eines Aircraft während des Aufenthalts. 0 = keine Bewegungen (Aircraft bleibt an einem Ort).",
          "example": "Beispiel: Aircraft kommt um 8:00 Uhr an, Abflug um 16:00 Uhr. Mit 1 erlaubten Umparken könnte es auf Spot A (8:00–12:00) parken und dann zu Spot B (12:00–16:00) wechseln, falls kein einzelner Spot für die vollen 8 Stunden verfügbar ist."
        },
        "allowTrapping": {
          "title": "Trapping erlauben",
          "description": "Wenn aktiviert, können Flugzeuge auch auf Positionen platziert werden, die Abfahrtswege anderer blockieren. Wenn deaktiviert, werden Flugzeuge nur auf Positionen platziert, die andere nicht einschließen (einige Flugzeuge bleiben möglicherweise unplatziert).",
          "example": "Beispiel: Eine Reihe hat die Positionen A (vorne) und B (hinten). Das Flugzeug auf B startet um 14:00 Uhr, das auf A um 16:00 Uhr. Ohne Blockierung kann B nicht genutzt werden (wäre blockiert). Mit erlaubter Blockierung können beide Positionen genutzt werden."
        },
        "egressWeight": {
          "title": "Abfluggewicht",
          "description": "Steuert, wie stark der Algorithmus Platzierungen vermeidet, die andere Flugzeuge blockieren.",
          "levels": {
            "low": "• Niedrig (1x): Minimale Einschränkung – bevorzugt Positionen ohne Blockierung, akzeptiert aber Blockierungen wenn nötig",
            "medium": "• Mittel (2x): Moderate Einschränkung – versucht stärker, Konflikte zu vermeiden, lässt Flugzeuge ggf. unplatziert",
            "high": "• Hoch (5x): Starke Gewichtung – bevorzugt stark Platzierungen ohne Fallen gegenüber der Anzahl der Platzierungen"
          },
          "example": "Beispiel: Spot A blockiert 2 Flugzeuge (Punktzahl = 2 × Gewichtung), Spot B blockiert 0 (Punktzahl = 0). Mit hoher Gewichtung (5x) erreicht Spot A 10 Punkte vs. Spot B 0 Punkte, wodurch Spot B stark bevorzugt wird."
        },
        "wasteWeight": {
          "title": "Abfallgewicht",
          "description": "Steuert, wie stark der Algorithmus vermeidet, kleine Flugzeuge auf überdimensionierten Stellplätzen zu platzieren. Hilft dabei, Premium-Großstellplätze für große Flugzeuge zu reservieren, die sie tatsächlich benötigen.",
          "levels": {
            "disabled": "• Deaktiviert (0x): Keine Strafe – ignoriert Abweichungen bei der Stellplatzgröße, Algorithmus platziert frei",
            "low": "• Niedrig (0,5x): Sanfter Hinweis – leichte Präferenz für passende Stellplätze",
            "medium": "• Mittel (1x): Ausgewogene Gewichtung – vergleichbar mit Abfluggewicht",
            "high": "• Hoch (2x): Starke Präferenz – vermeidet überdimensionierte Stellplätze aktiv",
            "veryHigh": "• Sehr hoch (3x): Extreme Einschränkung – reserviert große Stellplätze aggressiv für große Flugzeuge"
          },
          "example": "Beispiel: Citation (klein) auf einem Stellplatz für große Flugzeuge hat Verschwendung=3. Bei mittlerer Gewichtung (1x) ist die Verschwendungsstrafe=3. Bei hoher Gewichtung (2x) ist die Strafe=6. Wenn ein passender Stellplatz nur für kleine Flugzeuge Score=0 hat und ein großer Stellplatz Ausfahrtsstrafe=2, dann: Mittlere Gewichtung ergibt Scores 0 vs 5 (bevorzugt klein), Hohe Gewichtung ergibt Scores 0 vs 8 (stark bevorzugt klein)."
        },
        "sortingStrategy": {
          "title": "Sortierstrategie",
          "description": "Steuert die Reihenfolge, in der Flugzeuge vom Greedy-Platzierungsalgorithmus verarbeitet werden. Unterschiedliche Reihenfolgen können die Platzierungsraten erheblich beeinflussen.",
          "strategies": {
            "arrivalOrder": "• Ankunftsreihenfolge: Verarbeitung nach Ankunftszeit (früheste zuerst). Realistisch, aber kann flexible Slots verschwenden.",
            "sizeConstrained": "• Größenbeschränkung zuerst: Platziere Flugzeuge mit weniger kompatiblen Stellplätzen zuerst. Verhindert, dass flexible Stellplätze für flexible Flugzeuge verschwendet werden.",
            "longestDwell": "• Längste Verweildauer zuerst: Flugzeuge mit längster Aufenthaltsdauer zuerst platzieren. Lange Aufenthalte erhalten Priorität.",
            "latestDeparture": "• Spätester Abflug zuerst: Flugzeuge mit dem spätesten Abflug werden zuerst platziert. Optimiert die Übernacht-Parkposition.",
            "hybrid": "• Hybrid: Kombiniert größenbeschränkte und längste Verweildauer (am stärksten eingeschränkt + längste zuerst)."
          },
          "example": "Beispiel: 2 Plätze (A=nur Klein, B=Flex). Kleines Flugzeug kommt zuerst, Greedy platziert es auf B (verschwendet Flexibilität). Großes Flugzeug kommt, wird abgelehnt (nur B passt, jetzt belegt). Mit größenbeschränkter Reihenfolge: Großes zuerst auf B platziert, Kleines nimmt A → beide platziert!"
        },
        "sizeCategories": {
          "title": "Größenkategorien",
          "description": "Flugzeuge werden anhand ihrer Spannweite in Größenkategorien eingeteilt. Spots haben Richtlinien, die festlegen, welche Flugzeuggrößen sie akzeptieren – so lassen sich flexible Parkregeln umsetzen.",
          "sizes": {
            "verySmall": "• VS (Very Small): ~35-40ft Spannweite (Cessna 172, Piper PA-28, Cirrus SR22)",
            "small": "• S (Small): ~50-60ft Spannweite (Citations, Phenom 300, King Air 350, Learjet 45)",
            "midsize": "• M (Midsize): ~18-21m Spannweite (Challenger 604/605, Falcon 900, Gulfstream G280)",
            "superMidsize": "• SM (Super-Midsize): ~23-30m Spannweite (Falcon 7X, Gulfstream G500/G650)",
            "large": "• L (Large): ~30-37m Spannweite (Global 6000/7500, Gulfstream G700, BBJ)"
          },
          "spotPolicies": "Spot-Richtlinien: Jeder Spot hat eine Liste erlaubter Größen, die festlegt, welche Flugzeuge dort parken können.",
          "policies": {
            "universal": "• Universal: [VS, S, M, SM, L] – akzeptiert alle Flugzeuggrößen",
            "largeOnly": "• Nur Groß: [L] – reserviert Platz für große Flugzeuge (verhindert Verschwendung)",
            "commonJets": "• Gängige Jets: [S, M] - blockiert sehr kleine und große Flugzeuge"
          },
          "example": "Beispiel: Spot A01 erlaubt [S, M] (nur kleine und mittelgroße Flugzeuge). Ein großes Flugzeug (L) kommt an, kann aber A01 wegen der Größenbeschränkungen nicht nutzen. Es muss einen Spot finden, der große Flugzeuge erlaubt."
        }
      }
    },
    "decisionLogDisplay": {
      "noEntries": "Keine Protokolleinträge",
      "lane": "Spur",
      "timeConflict": "❌ Zeitkonflikt",
      "blocks": "📍 Blöcke",
      "deps": "✓ Abh.:",
      "aircraftSize": "Flugzeuggröße",
      "breakdown": "Aufgliederung",
      "collision": "Kollision",
      "depsWarning": "Abh.-Warnung",
      "durationAnalysis": {
        "exceedsBy": "Überschuss um",
        "minutes": "Minuten",
        "requiredDwell": "Mindestverweildauer",
        "spotLimit": "Stellplatzlimit",
        "title": "Daueranalyse"
      },
      "of": "Von",
      "otherOptions": "Weitere Optionen",
      "primary": "Primär",
      "primaryBlocker": "Hauptblocker",
      "quickFix": "Schnellfix",
      "rejectionReasons": {
        "durationExceeded": "Dauer überschritten",
        "geometryCollision": "Geometriekollision",
        "sizeIncompatible": "Größe inkompatibel",
        "spotsDisabled": "Spots deaktiviert",
        "timeConflicts": "Zeitkonflikte",
        "unknown": "Unbekannt"
      },
      "sizeAnalysis": {
        "aircraft": "Flugzeug",
        "length": "Länge",
        "none": "Keine",
        "spotsAllowing": "Erlaubte Plätze",
        "spotsBySize": "Plätze nach Größe",
        "title": "Größenanalyse",
        "wingspan": "Spannweite"
      },
      "spots": "Plätze",
      "timeAnalysis": {
        "aircraftDwell": "Flugzeug-Standzeit",
        "conflictWindow": "Konfliktfenster",
        "minutes": "Minuten",
        "minutesSuffix": "Minuten-Suffix",
        "peakCongestion": "Spitzenlast",
        "spotsOccupied": "Belegte Stellplätze",
        "spotsOccupiedSuffix": "Belegte Plätze Suffix",
        "timeConflicts": "Zeitkonflikte",
        "title": "Zeitanalyse"
      }
    }
  },
  "lastMinuteInsertion": {
    "dialog": {
      "aircraftStatus": {
        "spotUnknown": "Platz unbekannt",
        "unknown": "Unbekannt",
        "unplaced": "Offen"
      },
      "buttons": {
        "checkAvailability": "Verfügbarkeit prüfen",
        "close": "Schließen"
      },
      "errors": {
        "invalidTimeRange": "Fehler: Ungültiger Zeitraum"
      },
      "labels": {
        "aircraft": "Flugzeug",
        "arrivalTime": "Ankunftszeit",
        "departureTime": "Abflugzeit",
        "maxAircraftMoves": "Max. Flugzeugbewegungen"
      },
      "placeholders": {
        "selectAircraft": "Flugzeug auswählen"
      },
      "results": {
        "failed": {
          "suggestions": "Vorschläge",
          "title": "Fehler"
        },
        "localRepair": {
          "message": "Lokale Reparatur",
          "title": "Lokale Reparatur"
        },
        "zeroDisruption": {
          "message": "Null Unterbrechungen",
          "title": "Null Unterbrechungen"
        }
      },
      "slider": {
        "marks": {
          "max": "Max",
          "two": "Zwei",
          "zero": "Null"
        }
      },
      "title": "Dialog"
    }
  }
}
